export default {"src":"/_next/static/media/cardcover.b1edb41f.svg","height":114,"width":180,"blurWidth":0,"blurHeight":0};